import * as React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import AddIcon from "@mui/icons-material/Add";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography
} from "@mui/material";
import { UserMenuList } from "Static/utils/userMenuList";
import { matches } from "Static/utils/commonUtils";
import {
  PUCBreadActiveNavLink,
  PUCLocationButton,
  PUCNavLink,
  PucFillAddButton,
  PucOptions
} from "Helpers/overrides";
import variables from "Styles/variables.scss";
import { Paths } from "Router/Paths";
import { useServices } from "Hooks/ServicesContext";
import { useMutation } from "react-query";
import { useUserContext } from "Hooks/UserContext";

export default function UserBreadcrumbs() {
  const { userDetails, setuserDetails } = useUserContext();
  const { apiService } = useServices();
  const [pucTypeModal, setPucTypeModal] = React.useState(false);
  const [openStoreCodePopup, setOpenStoreCodePopup] = React.useState(false);
  const [selectedOption, setSelectedOption] = React.useState(null);
  const [disabledBtn, setdisabledBtn] = React.useState(true);
  const [storeCode, setStoreCode] = React.useState(null);
  const [checkRequestAbID, setCheckRequestAbID] = React.useState(null);
  const [breaddata, setBreadData] = React.useState({
    section: "",
    subSection: ""
  });

  const queryParams = new URLSearchParams(window.location.search);

  // Get specific parameter values
  const qparam = queryParams.get("from");

  const breadboxstyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row"
  };

  /**
   * Finds the title associated with the given path in the nested menu structure.
   *
   * @param {string} path - The path for which to find the associated title.
   * @param {array} menuList - The menu list to search through.
   * @returns {string|null} - The title associated with the path, or null if not found.
   */
  const findTitleByPath = (path, menuList) => {
    // Remove /view or /update from the path
    const cleanedPath = path.replace(matches.breadmatch, "");

    for (const menuGroup of menuList) {
      for (const menuItem of menuGroup.list) {
        if (menuItem.path === cleanedPath) {
          return menuItem;
        } else if (cleanedPath?.startsWith(menuItem.path) && menuItem.list) {
          // Recursively search for the title in the nested menu
          const nestedTitle = findTitleByPath(cleanedPath, menuItem.list);
          if (nestedTitle) {
            return nestedTitle;
          }
        }
      }
    }
    return null;
  };

  /**
   * useEffect hook to update the breadcrumb data based on the current window location pathname.
   */
  // Function to generate random number
  function generateRandomNumber(type) {
    try {
      // Generate a random number between 10000000 and 99999999
      const randomNumber = Date.now().toString().slice(8);

      // Combine the prefix 'PUC-' with the last 8 digits of the random number and current date
      const result = `${randomNumber}`; //`${type}-${randomNumber}`;

      return result;
    } catch (error) {}
  }

  React.useEffect(() => {
    const path = window.location.pathname;

    // Find the title associated with the current window location pathname
    const title = findTitleByPath(path, UserMenuList);

    // Set the breadcrumb data with the found section title
    setBreadData({
      section: title,
      subSection: ""
    });

    // Check for specific paths and update subSection accordingly
    if (path.includes("/view")) {
      setBreadData((prevData) => ({
        ...prevData,
        // subSection: title.view
        subSection: title?.view !== undefined || null ? title?.view : ""
      }));
    } else if (path.includes("/update")) {
      setBreadData((prevData) => ({
        ...prevData,
        // subSection: title.update
        subSection: title?.update !== undefined || null ? title?.update : ""
      }));
    } else if (path.includes("/add")) {
      setBreadData((prevData) => ({
        ...prevData,
        subSection: title?.add !== undefined ? title?.add : ""
      }));
    } else if (path.includes("/edit")) {
      setBreadData((prevData) => ({
        ...prevData,
        subSection: title?.edit
      }));
    }
  }, [window.location.pathname]);

  const handlePUCTypeModal = () => {
    setPucTypeModal(true);
  };

  const handleOptionClick = (option, from) => {
    try {
      setSelectedOption(option);
      setdisabledBtn(false);
    } catch (error) {}
  };

  // Fetch display wall store code data
  const { mutate: refetch } = useMutation(
    "fetchStoreCode",
    (data) => apiService.getRequest("display-wall/get-store-code"),
    {
      enabled: true, // Set to true when you want to trigger the query
      onSuccess: async (res, data) => {
        setStoreCode(res?.data?.store_code);
        setCheckRequestAbID(res?.data);
        // userDetails["store_code"] = res.data.store_code;
        setuserDetails({ ...userDetails, store_code: res?.data?.store_code });
        if (data) {
          storeCodeHandleApi(res?.data);
        }
      },
      onError: (error) => {
        // enqueueSnackbar(error.message, snackBarErrorConf);
      }
    }
  );

  // Calling Display wall Store Code api
  React.useEffect(() => {
    refetch(false);
    if (qparam == 'ecom') {
      setPucTypeModal(true);
    }
  }, []);

  // handle display wall when submitted form then show popup
  const storeCodeHandleApi = (storeCode) => {
    try {
      if (storeCode?.store_code) {
        setOpenStoreCodePopup(true);
        setPucTypeModal(false);
      } else if (storeCode?.request_AB_id) {
        const newWindow = window.open(`/${selectedOption}/${storeCode?.request_AB_id}`, "_blank");
        if (newWindow) {
          newWindow.opener = null; // Set opener to null to disassociate the new window from the current one
        }
        reset();
      } else {
        const newWindow = window.open(
          `/${selectedOption}/${generateRandomNumber(selectedOption)}`,
          "_blank"
        );
        if (newWindow) {
          newWindow.opener = null; // Set opener to null to disassociate the new window from the current one
        }
        reset();
      }
    } catch (error) {}
  };

  // handle PUCTypes selectedOption according show form
  const handleContinueClick = () => {
    // Use the selectedOption value as needed
    try {
      if (selectedOption === "display-wall") {
        refetch(true);
      } else {
        const newWindow = window.open(
          `/${selectedOption}/${generateRandomNumber(selectedOption)}`,
          "_blank"
        );
        if (newWindow) {
          newWindow.opener = null; // Set opener to null to disassociate the new window from the current one
        }
        reset();
      }
    } catch (error) {}
  };

  // Close store code popup
  const closeStoreCodePopup = () => {
    setOpenStoreCodePopup(false);
  };

  // Close popup when cancel form submit
  const reset = () => {
    setPucTypeModal(false);
    setdisabledBtn(true);
    setSelectedOption(null);
  };

  return (
    <Box sx={breadboxstyle}>
      <Box>
        {breaddata?.section?.title && (
          <Typography variant="h6">
            {breaddata.subSection ? `${breaddata.subSection}` : breaddata.section.title}
          </Typography>
        )}

        {breaddata?.section?.title === "Home" && breaddata?.subSection === "" ? (
          ""
        ) : (
          <Breadcrumbs aria-label="breadcrumb">
            {breaddata?.section?.title === "Home" && breaddata?.subSection !== "" ? (
              ""
            ) : (
              <PUCNavLink
                color="inherit"
                underline="hover"
                to={Paths.userDashboard}
                className={
                  window.location.pathname.replace(matches.breadmatch, "") ===
                  window.location.pathname
                    ? "breadactive"
                    : "breadnotactive"
                }>
                Home
              </PUCNavLink>
            )}

            <PUCNavLink
              className={
                window.location.pathname.replace(matches.breadmatch, "") ===
                window.location.pathname
                  ? "breadactive"
                  : "breadnotactive"
              }
              underline="hover"
              color="inherit"
              to={window.location.pathname.replace(matches.breadmatch, "")}
              aria-current="page">
              {breaddata?.section?.title}
            </PUCNavLink>
            {breaddata?.subSection ? (
              <PUCBreadActiveNavLink
                className={
                  window.location.pathname.replace(matches.breadmatch, "") ===
                  window.location.pathname
                    ? "breadnotactive"
                    : "breadactive"
                }
                underline="hover"
                color="inherit"
                to={window.location.pathname}
                aria-current="page">
                {breaddata?.subSection}
              </PUCBreadActiveNavLink>
            ) : (
              ""
            )}
          </Breadcrumbs>
        )}
      </Box>
      {window.location.pathname.includes("/view") ||
      window.location.pathname.includes("/update") ||
      window.location.pathname.includes("/add") ||
      window.location.pathname.includes("/edit") ? (
        ""
      ) : (
        <>
          {breaddata?.section?.add !== undefined ? (
            <PucFillAddButton
              onClick={() => {
                // handlePUC();
                handlePUCTypeModal();
              }}>
              <AddIcon />
              {breaddata?.section?.add}
            </PucFillAddButton>
          ) : (
            ""
          )}
        </>
      )}
      {/* puc-type-modal */}
      <Dialog fullWidth={true} open={pucTypeModal} minWidth={500}>
        <DialogTitle id="responsive-dialog-title">Select Store Type</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 1 }}>
              <Grid item xs={6} id='ww'>
                <PucOptions
                  onClick={() => handleOptionClick("wonder-world")}
                  style={selectedOption === "wonder-world" ? styles.active : styles.inactive}>
                  Wonder World
                </PucOptions>
              </Grid>
              <Grid item xs={6} id='wwq'>
                <PucOptions
                  onClick={() => handleOptionClick("wonder-world-quick")}
                  style={selectedOption === "wonder-world-quick" ? styles.active : styles.inactive}>
                  Wonder World Quick
                </PucOptions>
              </Grid>
              <Grid item xs={6} id='ks'>
                <PucOptions
                  onClick={() => handleOptionClick("keysoul-store")}
                  style={selectedOption === "keysoul-store" ? styles.active : styles.inactive}>
                  Keysoul Store
                </PucOptions>
              </Grid>
              <Grid item xs={6} id='dw'>
                <PucOptions
                  onClick={() => handleOptionClick("display-wall")}
                  style={selectedOption === "display-wall" ? styles.active : styles.inactive}>
                  {checkRequestAbID?.request_AB_id && !storeCode
                    ? "Resume Display Wall Application"
                    : "Display Wall"}
                </PucOptions>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={reset} color="inherit" variant="text" size="large">
            Cancel
          </Button>
          <PUCLocationButton
            variant="contained"
            size="large"
            color="primary"
            onClick={handleContinueClick}
            disabled={disabledBtn}>
            Continue
          </PUCLocationButton>
        </DialogActions>
      </Dialog>

      {/* Store Code Pupup */}
      <Dialog
        fullWidth={true}
        open={openStoreCodePopup}
        minWidth={500}
        onClose={closeStoreCodePopup}>
        <DialogContent>
          <DialogContentText>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center"
              }}>
              {/* <img src={ReviewImg} width={"300px"} /> */}
              <Typography variant="h5" mt={2}>{`"Your RCM Display Wall" permanent code is
        `}</Typography>
              <Typography variant="h5" mt={2}>
                <span>{storeCode}</span>
              </Typography>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenStoreCodePopup(false);
            }}
            // color="inherit"
            // variant="text"
            variant="contained"
            // size="large"
            color="error"
            size="large">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

const styles = {
  active: {
    color: variables.colorWhite,
    backgroundColor: variables.primary
  },
  inactive: {
    color: variables.primary,
    backgroundColor: variables.colorWhite
  }
};
